var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{ref:"page",staticClass:"home-page"},[_c('hero-section'),_c('featured-processes-section'),_c('creditor-access-section'),_c('institutional-section'),_c('news-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }